import * as types from './actionTypes';

export const updateProfile = (payload) => {
  return {
    type: types.UPDATE_PROFILE,
    payload,
  };
};
export const updateProfileSuccess = (payload) => {
  return {
    type: types.UPDATE_PROFILE_SUCCESS,
    payload,
  };
};
export const updateProfileError = (payload) => {
  return {
    type: types.UPDATE_PROFILE_ERROR,
    payload,
  };
};
